import { SubDialog } from '@/common/dialog/SubDialog';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useDialog } from '../dialog/DialogContext';
import { useNavState } from '../navState/NavStateContext';
import { TitleButton } from './TitleButton';

export const SubButton = () => {

  const { openDialog } = useDialog();
  const { entityObj, hist, asOfDate } = useEntityMgr();
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();
  const { mode } = useNavState();

  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  if (!hasRole(`${module.toUpperCase()}_${entity}_SAVE`)) return;

  const openSubDialog = () => {
    const data = {
      entity: entity,
      entityId: entityObj.id,
      uiType: mode,
    }
    openDialog(SubDialog, { data })
  }

  return (
    <TitleButton
      dataTestId="sub-upload-button"
      icon={fas.faUpload} //TODO: This and export button should mirror
      toolTip="Submit"
      disabled={hist || asOfDate}
      onClick={openSubDialog}
    />
  )
}